import React, { Component } from 'react';
import { connect } from 'react-redux';
import MenuItems from '../../components/MenuItems';
import OrderType from '../../components/OrderType';
import storeConfig from '../../configuration/storeConfig';
import { getPopulars, getStores, getSettings, getSuburbs } from './actions';
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/swiper.min.css';
import '../../assets/css/style.css';
import '../../assets/css/icon.css';
import '../../assets/css/responsive.css';
import '../../assets/css/animate.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { stores: [], settings: [], suburbs: [] };
    this.specialItemsObj = [];
  }

  componentDidMount() {
    this.props.getPopularsHandler(storeConfig.storeId);
    this.props.getStoresHandler();
    this.props.getSettingsHandler();
    this.props.getSuburbsHandler();
  }

  componentWillReceiveProps(props) {
    this.setState(
      {
        populars: props.home.populars,
        stores: props.home.stores,
        settings: props.home.settings,
        suburbs: props.home.suburbs,
      },
      () => {
        if (
          this.state.populars &&
          this.state.populars.length &&
          this.state.populars.length >= 1
        ) {
          this.setState({
            showShadow: true,
          });
        }
      }
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className={'container-fluid shadowIt'}>
          {this.state.showShadow === true && <div id='overlay'></div>}
          <div className='row'>
            <div className={'col-md-12 customWidth'}>
              <React.Fragment>
                <MenuItems populars={this.state.populars} />
              </React.Fragment>
            </div>
            {this.state.showShadow === true && (
              <OrderType
                stores={this.state.stores}
                settings={this.state.settings}
                suburbs={this.state.suburbs}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.homeReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPopularsHandler: (storeId) => dispatch(getPopulars(storeId)),
    getStoresHandler: () => dispatch(getStores()),
    getSettingsHandler: () => dispatch(getSettings()),
    getSuburbsHandler: () => dispatch(getSuburbs()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
